import PRIVILEGES from '../../constants/privileges';
import { useAuthStore } from '../../stores/useAuthStore';
import NavigationFooter from './navigation-footer/NavigationFooter';
import SideNav from './sidenav/SideNav';

const Navigation = () => {
  const logout = useAuthStore((state) => state.logout);

  const Menus = [
    {
      title: 'Dashboard',
      src: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M3 3h8v8H3V3zm0 10h8v8H3v-8zm10-10h8v5h-8V3zm0 7h8v11h-8V10z" />
        </svg>
      ),
      navigate: '/dashboard',
      privilege: PRIVILEGES.COMMON.GLOBAL_DASHBOARD_VIEW,
    },
    {
      title: 'Projects',
      src: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 17 19"
          fill="currentColor"
        >
          <path d="M17 3V5H14.3158V8H12.5263V5H9.8421V3H12.5263V0H14.3158V3H17ZM14.3158 17H1.78947V3H7.15789V1H1.78947C0.805263 1 0 1.9 0 3V17C0 18.1 0.805263 19 1.78947 19H14.3158C15.3 19 16.1053 18.1 16.1053 17V11H14.3158V17ZM10.7368 11V15H12.5263V11H10.7368ZM7.15789 15H8.94737V7H7.15789V15ZM5.36842 15V9H3.57895V15H5.36842Z" />
        </svg>
      ),
      navigate: '/',
      activeMatch: ['/', '/project'],
    },
    {
      title: 'Warehouse',
      src: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 15 15"
          fill="currentColor"
          version="1.1"
          id="warehouse"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5,5c-0.0762,0.0003-0.1514-0.0168-0.22-0.05L7.5,2L1.72,4.93C1.4632,5.0515,1.1565,4.9418,1.035,4.685
	S1.0232,4.1215,1.28,4L7.5,0.92L13.72,4c0.2761,0.0608,0.4508,0.3339,0.39,0.61C14.0492,4.8861,13.7761,5.0608,13.5,5z M5,10H2v3h3
	V10z M9,10H6v3h3V10z M13,10h-3v3h3V10z M11,6H8v3h3V6z M7,6H4v3h3V6z"
          />
        </svg>
      ),
      navigate: '/warehouse',
      privilege: PRIVILEGES.COMMON.WAREHOUSE_VIEW,
      activeMatch: ['/warehouse'],
    },

    {
      title: 'Materials',
      privilege: PRIVILEGES.COMMON.MATERIALS_VIEW,
      src: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 3H21V21H3V3Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M3 9H21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M3 15H21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M9 3V21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M15 3V21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ),
      children: [
        {
          title: 'Categories',
          navigate: '/settings/categories',
        },
        {
          title: 'Sub Categories',
          navigate: '/settings/subcategories',
        },
        {
          title: 'Items',
          navigate: '/settings/items',
        },
      ],
    },
    {
      title: 'Task',
      privilege: PRIVILEGES.COMMON.GLOBAL_TASK_VIEW,
      src: (
        <svg
          width="24"
          height="24"
          className="max-xs:h-[20px] max-xs:w-[20px]"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 19.5H21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 12.5H21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 5.5H21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 5.5L4 6.5L7 3.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 12.5L4 13.5L7 10.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 19.5L4 20.5L7 17.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      navigate: '/task-manager/all',
      activeMatch: ['/task-manager'],
    },
    {
      title: 'Materials Indent',
      privilege: PRIVILEGES.COMMON.MATERIAL_INDENT_VIEW,
      src: (
        <svg
          width="20"
          height="20"
          className="max-xs:h-[20px] max-xs:w-[20px]"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 7V9C10.5 10.1 9.6 11 8.5 11H6.5C5.4 11 4.5 10.1 4.5 9V7C4.5 5.9 5.4 5 6.5 5H8.5C9.6 5 10.5 5.9 10.5 7Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5 7V9C19.5 10.1 18.6 11 17.5 11H15.5C14.4 11 13.5 10.1 13.5 9V7C13.5 5.9 14.4 5 15.5 5H17.5C18.6 5 19.5 5.9 19.5 7Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 15V17C10.5 18.1 9.6 19 8.5 19H6.5C5.4 19 4.5 18.1 4.5 17V15C4.5 13.9 5.4 13 6.5 13H8.5C9.6 13 10.5 13.9 10.5 15Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5 15V17C19.5 18.1 18.6 19 17.5 19H15.5C14.4 19 13.5 18.1 13.5 17V15C13.5 13.9 14.4 13 15.5 13H17.5C18.6 13 19.5 13.9 19.5 15Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      navigate: '/materials-indent',
    },
    {
      title: 'Purchases',
      src: (
        <svg
          width="18"
          height="20"
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.75 2.75H2.75C1.64543 2.75 0.75 3.64543 0.75 4.75V16.75C0.75 17.8546 1.64543 18.75 2.75 18.75H12.75C13.8546 18.75 14.75 17.8546 14.75 16.75V15.75M4.75 2.75C4.75 3.85457 5.64543 4.75 6.75 4.75H8.75C9.85457 4.75 10.75 3.85457 10.75 2.75M4.75 2.75C4.75 1.64543 5.64543 0.75 6.75 0.75H8.75C9.85457 0.75 10.75 1.64543 10.75 2.75M10.75 2.75H12.75C13.8546 2.75 14.75 3.64543 14.75 4.75V7.75M16.75 11.75H6.75M6.75 11.75L9.75 8.75M6.75 11.75L9.75 14.75"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      children: [
        {
          title: 'Purchase Order',
          navigate: '/purchases/purchase-order',
          privilege: PRIVILEGES.COMMON.PURCHASE_ORDER_VIEW,
        },
        {
          title: 'Expenses',
          navigate: '/purchases/expenses',
          privilege: PRIVILEGES.COMMON.EXPENSES_VIEW_ALL,
        },
        {
          title: 'PO Bills',
          navigate: '/purchases/po-bills',
          privilege: PRIVILEGES.COMMON.PO_BILLS_VIEW,
        },
      ],
    },
    {
      title: 'Attendance',
      src: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 2V5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 2V5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.5 9.09H20.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      children: [
        {
          title: 'Locations',
          navigate: '/attendance/locations',
          privilege: PRIVILEGES.COMMON.ATTENDANCE_LOCATION_VIEW,
        },
        {
          title: 'Time Cards',
          navigate: '/attendance/schedules',
          privilege: PRIVILEGES.COMMON.ATTENDANCE_TIMECARD_VIEW,
        },
        {
          title: 'Mark Attendance',
          navigate: '/attendance/mark-attendance',
        },
        {
          title: 'My Attendance',
          navigate: '/attendance/my-attendance',
        },
        {
          title: 'My Payslip',
          navigate: '/attendance/my-payslip',
          privilege: PRIVILEGES.COMMON.GLOBAL_ATTENDENCE_MYPAYSLIP_VIEW,
        },
        {
          title: 'Shifts',
          navigate: '/attendance/shifts',
          privilege: PRIVILEGES.COMMON.ATTENDANCE_SHIFTS_VIEW,
        },
        {
          title: 'Attendance Register',
          navigate: '/attendance/register',
          privilege: PRIVILEGES.COMMON.ATTENDANCE_REGISTER_VIEW,
        },
        {
          title: 'Payslips',
          navigate: '/attendance/payslip',
          privilege: PRIVILEGES.COMMON.GLOBAL_ATTENDENCE_PAYSLIP_VIEW,
        },

        {
          title: 'Leave Management',
          navigate: '/attendance/leave-management',
          privilege: PRIVILEGES.COMMON.GLOBAL_ATTENDENCE_LEAVE_MANAGEMENT_VIEW,
        },
        {
          title: 'Apply Leave',
          navigate: '/attendance/apply-leave',
        },
        {
          title: 'Company Leaves',
          navigate: '/attendance/company-leaves',
        },
        {
          title: 'Global Attendance',
          navigate: '/attendance/global-attendance',
          privilege: PRIVILEGES.COMMON.GLOBAL_ATTENDENCE_COMPANY_LEAVES_VIEW,
        },
      ],
    },
    {
      title: 'Stock Hub',
      src: (
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.800781 0.800781H2.68967L3.06745 2.68967M4.57856 10.2452H14.023L17.8008 2.68967H3.06745M4.57856 10.2452L3.06745 2.68967M4.57856 10.2452L2.41305 12.4107C1.81808 13.0057 2.23946 14.023 3.08087 14.023H14.023M14.023 14.023C12.9798 14.023 12.1341 14.8687 12.1341 15.9119C12.1341 16.9551 12.9798 17.8008 14.023 17.8008C15.0662 17.8008 15.9119 16.9551 15.9119 15.9119C15.9119 14.8687 15.0662 14.023 14.023 14.023ZM6.46745 15.9119C6.46745 16.9551 5.62176 17.8008 4.57856 17.8008C3.53535 17.8008 2.68967 16.9551 2.68967 15.9119C2.68967 14.8687 3.53535 14.023 4.57856 14.023C5.62176 14.023 6.46745 14.8687 6.46745 15.9119Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      children: [
        {
          title: 'Stocks',
          navigate: '/stocks',
          privilege: PRIVILEGES.COMMON.GLOBAL_STOCKS_VIEW,
        },
        {
          title: 'Field Items',
          navigate: '/field-items',
          privilege: PRIVILEGES.COMMON.FIELD_ITEMS_VIEW_ALL,
        },
      ],
    },
    {
      title: 'Transportation',
      src: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 7H16V17H3V7Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M16 10H20L22 12V17H16V10Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="2" />
          <circle cx="18" cy="17" r="2" stroke="currentColor" strokeWidth="2" />
        </svg>
      ),
      children: [
        {
          title: 'Vehicles',
          navigate: '/admin/vehicles',
          privilege: PRIVILEGES.COMMON.VEHICLE_VIEW,
        },
        {
          title: 'Logistics',
          navigate: '/admin/logistics',
          privilege: PRIVILEGES.COMMON.GLOBAL_LOGISTICS_VIEW,
        },
        {
          title: 'Stock Issue',
          navigate: '/stocks/issue-stock',
          privilege: PRIVILEGES.COMMON.GLOBAL_STOCKS_VIEW,
        },
      ],
    },
    {
      title: 'Admin',
      src: (
        <svg
          width="18"
          height="14"
          viewBox="0 0 18 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.6992 12.6992H16.6992V11.1992C16.6992 9.95658 15.6247 8.94922 14.2992 8.94922C13.5347 8.94922 12.8537 9.28432 12.4142 9.80639M12.6992 12.6992H4.69922M12.6992 12.6992V11.1992C12.6992 10.707 12.5981 10.237 12.4142 9.80639M4.69922 12.6992H0.699219V11.1992C0.699219 9.95658 1.77374 8.94922 3.09922 8.94922C3.8637 8.94922 4.54471 9.28432 4.98422 9.80639M4.69922 12.6992V11.1992C4.69922 10.707 4.80036 10.237 4.98422 9.80639M4.98422 9.80639C5.57402 8.42499 7.01507 7.44922 8.69922 7.44922C10.3834 7.44922 11.8244 8.42499 12.4142 9.80639M11.0992 2.94922C11.0992 4.19186 10.0247 5.19922 8.69922 5.19922C7.37374 5.19922 6.29922 4.19186 6.29922 2.94922C6.29922 1.70658 7.37374 0.699219 8.69922 0.699219C10.0247 0.699219 11.0992 1.70658 11.0992 2.94922ZM15.8992 5.19922C15.8992 6.02765 15.1829 6.69922 14.2992 6.69922C13.4156 6.69922 12.6992 6.02765 12.6992 5.19922C12.6992 4.37079 13.4156 3.69922 14.2992 3.69922C15.1829 3.69922 15.8992 4.37079 15.8992 5.19922ZM4.69922 5.19922C4.69922 6.02765 3.98287 6.69922 3.09922 6.69922C2.21556 6.69922 1.49922 6.02765 1.49922 5.19922C1.49922 4.37079 2.21556 3.69922 3.09922 3.69922C3.98287 3.69922 4.69922 4.37079 4.69922 5.19922Z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      children: [
        {
          title: 'Roles',
          navigate: '/admin/roles',
          privilege: PRIVILEGES.COMMON.ROLES_VIEW,
        },
        {
          title: 'Employees',
          navigate: '/admin/employees',
          privilege: PRIVILEGES.COMMON.EMPLOYEES_VIEW,
        },
        {
          title: 'Labourers',
          navigate: '/admin/labourers',
          privilege: PRIVILEGES.COMMON.LABOURS_VIEW,
        },
        {
          title: 'Vendors',
          navigate: '/purchases/vendors',
          privilege: PRIVILEGES.COMMON.VENDORS_VIEW,
        },
        {
          title: 'Configuration',
          navigate: '/admin/project-types',
          privilege: PRIVILEGES.COMMON.GLOBAL_CONFIGURATION_VIEW,
        },

        {
          title: 'Master Tasks',
          navigate: '/admin/manage-master-tasks',
          privilege: PRIVILEGES.COMMON.MASTER_TASKS_VIEW,
        },
        {
          title: 'Gantt Chart',
          navigate: '/admin/gantt',
          // privilege: PRIVILEGES.COMMON.GANTT_VIEW,
        },
      ],
    },
    {
      title: 'Accounts',
      privilege: PRIVILEGES.COMMON.ACCOUNTS_VIEW,
      src: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>ic_fluent_mail_all_accounts_24_regular</title>
          <desc>Created with Sketch.</desc>
          <g
            id="accounts-Icons"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="ic_fluent_mail_all_accounts_24_regular"
              fill="#ffff"
              fillRule="nonzero"
            >
              <path
                d="M6.25,3 L17.75,3 C19.4830315,3 20.8992459,4.35645477 20.9948552,6.06557609 L21,6.25 L21,17.75 C21,19.4830315 19.6435452,20.8992459 17.9344239,20.9948552 L17.75,21 L6.25,21 C4.51696854,21 3.10075407,19.6435452 3.00514479,17.9344239 L3,17.75 L3,6.25 C3,4.51696854 4.35645477,3.10075407 6.06557609,3.00514479 L6.25,3 Z M8.32501359,14.5 L4.5,14.5 L4.5,17.75 C4.5,18.6681734 5.20711027,19.4211923 6.10647279,19.4941988 L6.25,19.5 L17.75,19.5 C18.6681734,19.5 19.4211923,18.7928897 19.4941988,17.8935272 L19.5,17.75 L19.5,14.5 L15.6749864,14.5 C15.3404023,16.1482847 13.9247166,17.4039882 12.2002976,17.4947422 L12,17.5 C10.2529748,17.5 8.78497652,16.3053441 8.36837329,14.6884005 L8.32501359,14.5 Z M17.75,4.5 L6.25,4.5 C5.3318266,4.5 4.57880766,5.20711027 4.5058012,6.10647279 L4.5,6.25 L4.5,13 L9,13 C9.37969577,13 9.69349096,13.2821539 9.74315338,13.6482294 L9.75,13.75 C9.75,14.9926407 10.7573593,16 12,16 C13.190864,16 14.1656449,15.0748384 14.2448092,13.9040488 L14.25,13.75 C14.25,13.3703042 14.5321539,13.056509 14.8982294,13.0068466 L15,13 L19.5,13 L19.5,6.25 C19.5,5.3318266 18.7928897,4.57880766 17.8935272,4.5058012 L17.75,4.5 Z M6.75,9.5 L17.25,9.5 C17.6642136,9.5 18,9.83578644 18,10.25 C18,10.6296958 17.7178461,10.943491 17.3517706,10.9931534 L17.25,11 L6.75,11 C6.33578644,11 6,10.6642136 6,10.25 C6,9.87030423 6.28215388,9.55650904 6.64822944,9.50684662 L6.75,9.5 L17.25,9.5 L6.75,9.5 Z M6.75,6.5 L17.25,6.5 C17.6642136,6.5 18,6.83578644 18,7.25 C18,7.62969577 17.7178461,7.94349096 17.3517706,7.99315338 L17.25,8 L6.75,8 C6.33578644,8 6,7.66421356 6,7.25 C6,6.87030423 6.28215388,6.55650904 6.64822944,6.50684662 L6.75,6.5 L17.25,6.5 L6.75,6.5 Z"
                id="Color"
              ></path>
            </g>
          </g>
        </svg>
      ),
      navigate: '/accounts',
    },
    {
      title: 'CRM',
      src: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45768C17.623 10.1593 16.8604 10.6597 16 10.88"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      children: [
        {
          title: 'Leads',
          navigate: '/crm/leads',
          privilege: PRIVILEGES.COMMON.CRM_LEADS_PAGE_VIEW,
        },
        {
          title: 'Activities',
          navigate: '/crm/activities',
          privilege: PRIVILEGES.COMMON.CRM_ACTIVITY_PAGE_VIEW,
        },
        {
          title: 'Follow-ups',
          navigate: '/crm/followups',
          privilege: PRIVILEGES.COMMON.CRM_FOLLOWUP_PAGE_VIEW,
        },
        {
          title: 'Settings',
          navigate: '/crm/settings',
          privilege: PRIVILEGES.COMMON.CRM_SETTINGS_PAGE_VIEW,
        },
      ],
    },
    {
      title: 'Pending Actions',
      privilege: PRIVILEGES.COMMON.PENDING_ACTIONS_VIEW,
      src: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 1024 1024"
          className="icon"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M182.99 146.2h585.14v402.29h73.14V73.06H109.84v877.71H512v-73.14H182.99z"
            stroke="currentColor"
            fill="#ffff"
          />
          <path
            d="M256.13 219.34h438.86v73.14H256.13zM256.13 365.63h365.71v73.14H256.13zM256.13 511.91h219.43v73.14H256.13zM731.55 585.06c-100.99 0-182.86 81.87-182.86 182.86s81.87 182.86 182.86 182.86c100.99 0 182.86-81.87 182.86-182.86s-81.86-182.86-182.86-182.86z m0 292.57c-60.5 0-109.71-49.22-109.71-109.71 0-60.5 49.22-109.71 109.71-109.71 60.5 0 109.71 49.22 109.71 109.71 0.01 60.49-49.21 109.71-109.71 109.71z"
            stroke="currentColor"
            fill="#ffff"
          />
          <path
            d="M758.99 692.08h-54.86v87.27l69.39 68.76 38.61-38.96-53.14-52.66z"
            stroke="currentColor"
            fill="#ffff"
          />
        </svg>
      ),
      navigate: '/pending-actions',
    },
    {
      title: 'Reports',
      privilege: PRIVILEGES.COMMON.REPORTS_VIEW_ALL,
      src: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          fill="#ffffff"
        >
          <title>report</title>

          <rect x="15" y="20" width="2" height="4" />
          <rect x="20" y="18" width="2" height="6" />
          <rect x="10" y="14" width="2" height="10" />

          <path d="M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z" />

          <rect width="32" height="32" fill="none" />
        </svg>
      ),
      navigate: '/reports',
    },
    {
      title: 'Company Details',
      privilege: PRIVILEGES.COMMON.COMPANY_DETAILS_VIEW,
      src: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8611 17.75V2.63889C15.8611 1.59568 15.0154 0.75 13.9722 0.75H4.52778C3.48457 0.75 2.63889 1.59568 2.63889 2.63889V17.75M15.8611 17.75L17.75 17.75M15.8611 17.75H11.1389M2.63889 17.75L0.75 17.75M2.63889 17.75H7.36111M6.41667 4.52776H7.36111M6.41667 8.30553H7.36111M11.1389 4.52776H12.0833M11.1389 8.30553H12.0833M7.36111 17.75V13.0278C7.36111 12.5062 7.78395 12.0833 8.30556 12.0833H10.1944C10.716 12.0833 11.1389 12.5062 11.1389 13.0278V17.75M7.36111 17.75H11.1389"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      navigate: '/admin/company-details',
    },
    {
      title: 'Profile',
      src: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 11.916C12.5188 11.916 13.75 10.6848 13.75 9.16602C13.75 7.64723 12.5188 6.41602 11 6.41602C9.48122 6.41602 8.25 7.64723 8.25 9.16602C8.25 10.6848 9.48122 11.916 11 11.916Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.65234 17.2776C6.11823 15.727 7.54595 14.6655 9.16501 14.666H12.8317C14.4529 14.6655 15.8821 15.7297 16.3462 17.2831"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      navigate: '/profile',
    },

    {
      title: 'Logout',
      src: (
        <svg
          width="24"
          height="24"
          className="max-xs:h-[20px] max-xs:w-[20px]"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 12H3.62"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      onClick: logout,
    },
  ];

  return (
    <>
      <div className="sticky top-0 hidden h-screen bg-white md:block ">
        <SideNav menus={Menus} />
      </div>
      <div className="md:hidden">
        <NavigationFooter menus={Menus} />
      </div>
    </>
  );
};

export default Navigation;
